export const setTitle = (title: string) => {
    if (document.getElementsByTagName('title').length > 0 && typeof document.getElementsByTagName('title')[0] !== "undefined") {
        // @ts-expect-error can be undefined
        document.getElementsByTagName('title')[0].innerHTML = title + " | Pay";
    }
}
